import { render } from "./AgentDashboard.vue?vue&type=template&id=6e723e3a&scoped=true"
import script from "./AgentDashboard.vue?vue&type=script&lang=js"
export * from "./AgentDashboard.vue?vue&type=script&lang=js"

import "./AgentDashboard.vue?vue&type=style&index=0&id=6e723e3a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e723e3a"]])

export default __exports__